import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@fukuri-admins/ui/common/Form/FormItems/Select/legacy';
import styles from './styles.module.scss';

type UsersScope = 'at_publication' | 'all';

const SCOPE_OPTIONS = [
  { value: 'at_publication', label: '公開時点の利用者' },
  { value: 'all', label: 'すべての利用者' },
] as const satisfies ReadonlyArray<{ value: UsersScope; label: string }>;

type Props = {
  value: UsersScope;
  onChange: (scope: UsersScope) => void;
};

/**
 * 閲覧率の母数スコープを選択するセレクト
 * 「公開時点の利用者」と「すべての利用者」を切り替える
 */
export const UsageScopeSelect: React.FC<Props> = ({ value, onChange }) => (
  <div className={styles.wrapper}>
    <p className={styles.label}>対象</p>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={styles.trigger}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {SCOPE_OPTIONS.map(option => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
